import { render, staticRenderFns } from "./TimeAllocationView.vue?vue&type=template&id=164a2f94&scoped=true"
import script from "./TimeAllocationView.vue?vue&type=script&lang=js"
export * from "./TimeAllocationView.vue?vue&type=script&lang=js"
import style0 from "./TimeAllocationView.vue?vue&type=style&index=0&id=164a2f94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164a2f94",
  null
  
)

export default component.exports